module.exports = __webpack_public_path__ + "static/divya-243dcdbd97e0b86536283622bbb5de2f.jpg";